import { theme } from '@features/executive-report/domain/theme';
import { TextProps } from '@features/powerpoint';
import { contentSlideTitleText } from '../../../../slides/content-slide-title-text';
import { SECTION_X_OFFSET } from './layout';
import { formatters } from '@utils/formattersV2';
import { formatWithSign } from '@features/executive-report/utils/format-with-sign';
import { SalesOptimizationSummaryOptions } from '../sales-optimization-summary';
import { campaignTexts } from './campaign-texts';
import { headerTabs } from '../header-tabs';

export const texts = (
  options: SalesOptimizationSummaryOptions
): TextProps[] => [
  ...headerTabs('summary'),
  contentSlideTitleText('<lci>Optimization</lci> <b>Summary</b>'),
  {
    text: 'Sales Lift'.toUpperCase(),
    options: {
      fontSize: 10,
      color: theme.colors.white,
      bold: true,
      h: 0.18,
      w: 1.01,
      x: 9.79,
      y: 1.34,
    },
  },
  {
    text: formatWithSign(options.currentReport.incrementalSalesLift, value =>
      formatters.lift(value, { decimals: 1 })
    ),
    options: {
      fontSize: 36,
      color: theme.colors.inmarketGreen,
      align: 'right',
      h: 0.71,
      w: 2.5,
      x: 10.45,
      y: 1.08,
    },
  },
  ...campaignTexts({
    period: 'middle',
    xOffset: 0,
    report: options.midCampaignReport,
  }),
  ...campaignTexts({
    period: 'end',
    xOffset: SECTION_X_OFFSET,
    report: options.currentReport,
  }),
];
